const CASE_REF_PREFIX = "c";
const CASE_REF_MULTIPLIER = 7919;
const CASE_REF_OFFSET = 104729;
const CASE_REF_CHECKSUM_MOD = 97;

const normalizeCaseId = (caseId) => {
  const parsedId = Number.parseInt(caseId, 10);
  return Number.isInteger(parsedId) && parsedId > 0 ? parsedId : null;
};

const buildChecksum = (caseId) => ((caseId * 13) + 17) % CASE_REF_CHECKSUM_MOD;

export const encodeAnalyticsCaseRef = (caseId) => {
  const normalizedCaseId = normalizeCaseId(caseId);
  if (!normalizedCaseId) {
    return null;
  }

  const obfuscatedId = (normalizedCaseId * CASE_REF_MULTIPLIER) + CASE_REF_OFFSET;
  return `${CASE_REF_PREFIX}${obfuscatedId.toString(36)}-${buildChecksum(normalizedCaseId).toString(36)}`;
};

export const decodeAnalyticsCaseRef = (caseRef) => {
  const normalizedCaseId = normalizeCaseId(caseRef);
  if (normalizedCaseId) {
    return normalizedCaseId;
  }

  if (typeof caseRef !== "string" || !caseRef.startsWith(CASE_REF_PREFIX)) {
    return null;
  }

  const [encodedBody, encodedChecksum] = caseRef.slice(CASE_REF_PREFIX.length).split("-");
  if (!encodedBody || !encodedChecksum) {
    return null;
  }

  const obfuscatedId = Number.parseInt(encodedBody, 36);
  const checksum = Number.parseInt(encodedChecksum, 36);
  if (!Number.isInteger(obfuscatedId) || !Number.isInteger(checksum)) {
    return null;
  }

  const decodedCaseId = (obfuscatedId - CASE_REF_OFFSET) / CASE_REF_MULTIPLIER;
  if (!Number.isInteger(decodedCaseId) || decodedCaseId <= 0) {
    return null;
  }

  return buildChecksum(decodedCaseId) === checksum ? decodedCaseId : null;
};

export const buildAnalyticsCaseDetailPath = (caseId) => {
  const caseRef = encodeAnalyticsCaseRef(caseId);
  return caseRef ? `/fleet/analytics/cases/${caseRef}` : "/fleet/analytics";
};
